<div id="orange-bg">

</div>
<!--section parallax bg1-->
<div class="orange-ramadan-banner ">
    <div class="overlay-layer-bottom"></div>

    <!--<div class="overlay-layer "></div>-->

    <div class="logo">
        <img src="assets/img/orange-ramadan/orange-logo.png" alt="orange-logo">
    </div>
    <div class="logo2">
        <img src="assets/img/games/pubg/logo.png" alt="">
    </div>

    <div class="container" style="height:100%;">

        <div class="flex_block column" style="height:100%;">

            <div class="content">
                <div class="r">
                    <h1>هتنافس علي دورة</h1>
                    <img src="assets/img/orange-ramadan/el-la3eb-logo.svg" width="100" alt="El-la3eb logo">

                    <h1>الرمضانية وانت في بيتك</h1>
                </div>

                <div class="l">
                    <h1> بمجموع جوائز </h1>
                    <h2>50,000</h2>
                    <h1 style="margin:0;">جنية مصرى </h1>
                    <h3>ابعت 1 ل 6545 و تابع الدورات الجاية</h3>
                </div>
            </div>

            <div class="partners">
                <div class="r">
                    <img src="assets/img/orange-ramadan/vl-logo.png" alt="">
                    <img src="assets/img/orange-ramadan/ah-logo.png" alt="">
                    <img src="assets/img/orange-ramadan/orange-esports-logo.png" alt="">
                </div>

                <div class="l">
                    <img src="assets/img/orange-ramadan/pubg-copyrights-logo.png" width="300" alt="">
                </div>
            </div>
        </div>

    </div>

</div>

<div class="prizes_container">

        <div class="item">
            <h1>الفائز الاول</h1>
            <h3>25,000 EGP</h3>
            <img src="assets/img/orange-ramadan/cash-logo.png" width="100" alt="">
        </div>

  <div class="item">
    <h1>الفائز الثاني</h1>
    <h3>15,000 EGP</h3>
    <img src="assets/img/orange-ramadan/cash-logo.png" width="100" alt="">
  </div>
  <div class="item">
    <h1>الفائز الثالث</h1>
    <h3>10,000 EGP</h3>
    <img src="assets/img/orange-ramadan/cash-logo.png" width="100" alt="">  </div>
<!--        <div class="item">-->
<!--            <h1>الفائز الثاني</h1>-->
<!--            <h3>iPhone 11</h3>-->
<!--            <img src="assets/img/orange-ramadan/iphone-logo.png" height="100" alt="">-->
<!--        </div>-->
<!--        <div class="item">-->
<!--            <h1>الفائز الثالث</h1>-->
<!--            <h3>Playstation 4</h3>-->
<!--            <img src="assets/img/orange-ramadan/ps4-logo.png" width="100" alt="">-->
<!--        </div>-->
</div>


<app-orange-ramadan-tournaments></app-orange-ramadan-tournaments>

<app-orange-ramadan-footer></app-orange-ramadan-footer>
